import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';

import { CLAIMS } from '../../../navigation/routes.constants';

import './FinishButton.css';

const FinishButton = () => {
  const { t } = useTranslation('claims');
  const history = useHistory();

  const onFinishPress = () => {
    history.push(CLAIMS);
  };

  return (
    <button
      className="Finish-button-button"
      onClick={onFinishPress}
      onKeyDown={() => {}}
      type="button"
    >
      {t('newClaim.noEligiblePetsButton')}
    </button>
  );
};

export { FinishButton };
